import  { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "../../../components/atoms/Button";
import styles from "./index.module.css";
import { useNavigate } from "react-router-dom";
import InputText from "../../../components/atoms/InputText";
import Label from "../../../components/atoms/Label";
import ArrowLeft from "../../../images/icons/arrow_left.svg";
import Navbar from "../../../components/molecules/Navbar";
import Footer from "../../../components/molecules/Footer";
import FeemonkText from "../../../components/atoms/FeemonkText";
import { /* createApplication */ } from "../../../services/application";
// network libraries removed; only stage API (fetch) and OTP stubs are kept
import { ApplicantStage } from "../../../utils/applicationStage";
// helpers removed

function EnterMobile() {
  const pathSegments = window.location.pathname.split('/');
  const encodedData = pathSegments[pathSegments.length - 1];
  const data = encodedData;
  const location = useLocation();
  const [loading,setLoading] = useState(false);
  const navigate = useNavigate();
  let [userData, setUserData] = useState<{
    application:string,
    dob:string,
    applicationId: string;
    userId: string;
    email: string;
    panId: string;
    dateOfBirth: string;
    instituteId: string;
    firstName: string;
    lastName: string;
    mobile: string;
    course: string;
    fees: number;
    studentName: string;
    instituteName: string;
    redirectUrl: string;
    channelId: number;
    flow:string;
  }>({
    application:'',
    applicationId: "",
    userId: "",
    instituteId: "",
    firstName: "",
    lastName: "",
    panId: "",
    dateOfBirth: "",
    dob:'',
    email: "",
    mobile: "",
    course: "",
    fees: 0,
    studentName: "",
    instituteName: "",
    redirectUrl: "",
    channelId: 0,
    flow:''
  });

  const [mobileInput, setMobileInput] = useState('');
  const [otpInput, setOtpInput] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState('');
  const [sendingOtp, setSendingOtp] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [mobileOtpResponse, setMobileOtpResponse] = useState<any>(null);

  const [error, setError] = useState("");
  
  useEffect(() => {
    if (data) {
      try {
        const jsonData = atob(data);
        try {
          const parsed = JSON.parse(jsonData);
          sessionStorage.setItem("data", data);
          setUserData(parsed);
        } catch (err) {
          console.error("Error parsing encoded data:", err);
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      console.log("No encoded data available, skipping getPanDetails");
    }
  }, []);

    // Helper to decode session/URL payload
    const getDecodedData = () => {
      try {
        const raw = sessionStorage.getItem("data") || data;
        if (!raw) return null;
        const json = atob(raw);
        return JSON.parse(json);
      } catch (err) {
        return null;
      }
    };

    const extractIdsFromToken = () => {
      try {
        const token = sessionStorage.getItem("token") || localStorage.getItem("token");
        if (!token) return null;
        if (typeof token === 'string' && token.split && token.split('.').length === 3) {
          const payload = token.split('.')[1];
          const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
          return { applicationId: decoded?.applicationId, userId: decoded?.userId };
        }
        try {
          const parsed = JSON.parse(token);
          return { applicationId: parsed.applicationId, userId: parsed.userId };
        } catch (e) {
          return null;
        }
      } catch (err) {
        return null;
      }
    };

    const checkApplicationStage = (checkoutData: any) => {
      if (!checkoutData?.applicationId) return;
      fetch(
        `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${checkoutData.applicationId}`
      )
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.json();
        })
        .then((res) => {
          if (res?.data?.stage) {
            switch (res?.data?.stage) {
              case ApplicantStage.PanVerification:
                navigate("/address-details", { state: { data: userData } });
                break;
              case ApplicantStage.EmploymentDetails:
                navigate("/work-details", { state: { data: userData } });
                break;
              case ApplicantStage.AddressDetails:
                navigate("/address-details", { state: { data: userData } });
                break;
              case ApplicantStage.BankStatement:
                navigate("/view-offers", { state: { data: userData } });
                break;
              case ApplicantStage.AwaitingApproval:
              case ApplicantStage.CoapplicantRequired:
              case ApplicantStage.AwaitingCoapplicantConsent:
                navigate("/parking-page", { state: { data: userData } });
                break;
              case ApplicantStage.Approved:
                navigate("/select-emi", { state: { data: userData } });
                break;
              case ApplicantStage.SanctionTermsAccepted:
              case ApplicantStage.Digilocker:
              case ApplicantStage.Selfie:
              case ApplicantStage.Agreement:
              case ApplicantStage.BankAccountVerified:
                navigate("/sanctions", { state: { data: userData } });
                break;
              case ApplicantStage.Mandate:
                navigate("/pf-collection", { state: { data: userData } });
                break;
              case ApplicantStage.ProcessComplete:
              case ApplicantStage.Disbursed:
                navigate("/disbursed-page", { state: { data: userData } });
                break;
              case ApplicantStage.PFCollections:
                navigate("/pf-collection", { state: { data: userData } });
                break;
              case ApplicantStage.Rejected:
                navigate("/rejected-page", { state: { data: userData } });
                break;
              default:
                navigate(`/pan-details/:data`);
                break;
            }
          }
        })
        .catch((err) => {
          console.error("Error checking application stage:", err);
        });
    };

    // Run stage check on mount and on navigation changes. Only call if we have applicationId+userId
    useEffect(() => {
      const decoded = getDecodedData();
      if (decoded && decoded.applicationId && decoded.userId) {
        checkApplicationStage(decoded);
        return;
      }
      const ids = extractIdsFromToken();
      if (ids && ids.applicationId && ids.userId) {
        checkApplicationStage(ids);
      }
    }, [location]);

  const [checked, setChecked] = useState(false);
  
  const sendOtp = async () => {
    const mobile = mobileInput?.trim();
    if (!/^[6-9]\d{9}$/.test(mobile)) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }

    setError("");
    setSendingOtp(true);

    const getNameFromToken = () => {
      try {
        const token = sessionStorage.getItem("token") || localStorage.getItem("token") || (userData && (userData as any).token);
        if (!token) return null;
        if (typeof token === "string" && token.split && token.split('.').length === 3) {
          const payload = token.split('.')[1];
          const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
          return decoded?.name || decoded?.fullName || null;
        }
        try {
          const parsed = JSON.parse(token);
          return parsed.name || parsed.fullName || null;
        } catch (e) {
          return null;
        }
      } catch (err) {
        return null;
      }
    };

    const fullNameFromToken = getNameFromToken();
    let firstName = userData?.firstName || "";
    let lastName = userData?.lastName || "";
    if (fullNameFromToken) {
      const parts = fullNameFromToken.trim().split(/\s+/);
      firstName = parts[0] || firstName;
      lastName = parts.slice(1).join(' ') || lastName;
    }

    try {
      const baseUrl = process.env.REACT_APP_DASHBOARD_URL;
      const res = await fetch(`${baseUrl}/login/mobile-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          accept: '*/*'
        },
        body: JSON.stringify({
          mobile,
          firstName,
          lastName,
          channelId: userData?.channelId
        })
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Send OTP failed: ${res.status} ${text}`);
      }

      const json = await res.json();
      console.log("json--->",json)
      setOtpSent(true);
      if (json?.data && typeof json.data === 'object') {
        setMobileOtpResponse(json.data);
        // if backend returned channelId update local userData
        if (json.data.channelId) {
          setUserData((prev) => ({ ...prev, channelId: json.data.channelId }));
        }
      }
    } catch (err: any) {
      console.error(err);
      setError(err?.message || 'Failed to send OTP');
    } finally {
      setSendingOtp(false);
    }
  };

  const verifyOtp = async () => {
    setVerifyingOtp(true);
    setError("");

    try {
      const baseUrl = process.env.REACT_APP_DASHBOARD_URL;
      // Branch verify flow based on userType returned by mobile-otp
      const userType = mobileOtpResponse?.userType;
      if (userType === 1) {
        // For userType 1, call login/verify-otp with mobile + otp and
        // navigate to pan-details with the data returned by mobile-otp
        const res = await fetch(`${baseUrl}/login/verify-otp`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            accept: '*/*'
          },
          body: JSON.stringify({
            mobile: mobileInput?.trim(),
            otp: otpInput?.trim()
          })
        });

        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Verify OTP failed: ${res.status} ${text}`);
        }

        // ignore verify response payload and send the original mobile-otp data
        // to pan-details as requested
        sessionStorage.setItem('data', data);
        navigate(`/pan-details`, { state: { data: mobileOtpResponse } });
      } else {
        // Default / userType 2: existing verify flow
        const res = await fetch(`${baseUrl}/summary/mobile-360-verify-otp`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            accept: '*/*'
          },
          body: JSON.stringify({
            mobile: mobileInput?.trim(),
            otp: otpInput?.trim(),
            channelId: userData?.channelId 
          })
        });

        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Verify OTP failed: ${res.status} ${text}`);
        }

        const json = await res.json();
        if (json?.data) {
          sessionStorage.setItem('data', data);
          navigate(`/pan-details`, { state: { data: json.data } });
        } else {
          throw new Error(json?.message || 'OTP verification failed');
        }
      }
    } catch (err: any) {
      console.error(err);
      setError(err?.message || 'Invalid OTP. Please try again.');
    } finally {
      setVerifyingOtp(false);
    }
  };
  const handleCheck = (event: any) => {
    setChecked(event);
  };  
  return (
    <div className={styles.body}>
      {error && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "1000",
          }}
          onClick={() => setError("")}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "1rem 1rem",
              borderRadius: "10px",
              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
              margin: "0 1rem",
              
            }}
            onClick={() => setError("")}
          >
            <h5
              style={{
                fontFamily: "Outfit",
                textAlign: "center",
                fontSize:'16px'
              }}
            >
              <span style={{color:'#d32028'}}>Error:{' '}</span>{error}
            </h5>
          </div>
        </div>
      )}
    
      <div className={styles.backdrop}>
        <Navbar />
        <div className={styles.container}>
          <div className={styles.content}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Label text="Mobile number" left />
              <InputText
                square
                placeholder="Enter mobile number"
                changeHandler={(e) => setMobileInput(e.target.value)}
                value={mobileInput}
                type="tel"
              />
              <br />

              {otpSent && (
                <>
                  <Label text="OTP" left />
                  <InputText
                    square
                    placeholder="Enter OTP"
                    changeHandler={(e) => setOtpInput(e.target.value)}
                    value={otpInput}
                  />
                  <br />
                </>
              )}

            </div>
            <br/>
            <div
              style={{
                display:'flex',
              }}
            >
              <input
                type="checkbox"
                onChange={(e: any) => handleCheck(e.target.checked)}
                style={{
                  marginRight: "10px",
                  height: "25px",
                  width: "25px",
                }}
                checked={checked}
              />
              <p className={styles.consentText}>
                I consent and authorize <FeemonkText /> to get a background
                check and a consumer credit report on me.
              </p>
            </div>
          </div>
          <Button
            onPress={() => {
              otpSent ? verifyOtp() : sendOtp();
            }}
            imageRight={ArrowLeft}
            text={sendingOtp ? "Sending.." : verifyingOtp ? "Verifying.." : otpSent ? "Verify OTP" : "Send OTP"}
              disabled={
                sendingOtp || verifyingOtp || !checked || (!otpSent ? mobileInput.trim().length !== 10 : otpInput.trim().length < 4)
              }
            insureFin={userData?.channelId === 5}
          />
        </div>
        <br />
        <Footer />
      </div>
    </div>
  );
}

export default EnterMobile;
